import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "edpDecimalSplit"
})
export class EdpDecimalSplitPipe implements PipeTransform {

  transform(value: string, split: string = ",", unit?: string): string {
    const parts = parseFloat(value).toFixed(2).split(".");
    const currency = !!unit ? unit : "€";
    const part2 = !!unit ? `${parts[1]} ${currency}` : `${parts[1]}${currency}`;
    return `${parts[0]}${split}<span class="pipe-decimal">${part2}</span>`;
  }

}
